export default __webpack_public_path__ + "static/media/mail-sent.63ad877d.svg";